export { default as mergeOptions } from 'deepmerge'

/**
 * Stores the default color palette.
 */
export const colorPalette = [
  '#667EEA',
  '#F56565',
  '#48BB78',
  '#ED8936',
  '#9F7AEA',
  '#38B2AC',
  '#ECC94B',
  '#4299E1',
  '#ED64A6',
]
